import { TableBody, TableRow } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ALL_NS } from '~/i18n/namespaces'
import { EFTypography } from '../EFTypography'
import { EFErrorDataTableProp } from './EFErrorPageContent.model'
import classNames from 'classnames/bind'
import styles from './EFErrorPageContent.module.scss'
import { ErrorPopupContent } from '../popups'
import { EFTableCell } from '../EFTable'

const cx = classNames.bind(styles)
export function EFErrorDataTable({ error }: EFErrorDataTableProp) {
  const { t } = useTranslation(ALL_NS)

  return (
    <TableBody>
      <TableRow>
        <EFTableCell
          className={cx('error-table-cell')}
          colSpan={12}
          align='center'
        >
          {error ? (
            <ErrorPopupContent error={error} />
          ) : (
            <EFTypography className={cx('error-text')}>
              {t('Message_NoTableResult')}
            </EFTypography>
          )}
        </EFTableCell>
      </TableRow>
    </TableBody>
  )
}
